import { render, staticRenderFns } from "./RentalObjectOverview.vue?vue&type=template&id=b8ec1260&"
import script from "./RentalObjectOverview.vue?vue&type=script&lang=js&"
export * from "./RentalObjectOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports